import clsx from 'clsx';
import type { JSX, ReactNode } from 'react';

export interface PublicPageLayoutProps {
  children: ReactNode;
  className?: string;
}

export function PublicPageLayout({ children, className }: PublicPageLayoutProps): JSX.Element {
  return (
    <div
      className={clsx(
        'max-w-screen flex min-h-screen w-full flex-col overflow-x-hidden bg-surface-light text-text-primary',
        className,
      )}
    >
      {children}
    </div>
  );
}

export { PublicPageSection } from './PublicPageSection';
export type { PublicPageSectionProps } from './PublicPageSection';
